<script lang="ts" setup>
import { ref } from "vue";

const toggled = ref(false);

function blur() {
  if (toggled.value === true) {
    toggle();
  }
}

function toggle() {
  toggled.value = !toggled.value;
}
</script>

<style>
* {
  transition: background-color 0.2s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<template>
  <div class="warning-popup" :class="{ active: toggled }">
    <v-icon class="icon-warning" @click="toggle" ref="input" v-on:blur="blur()">mdi-alert</v-icon>

    <transition name="fade">
      <div class="warning-dropdown" v-show="toggled === true">
        <div class="warning-dropdown-header">
          <slot name="header"></slot>
        </div>

        <div class="warning-dropdown-content">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>
